var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"-home"},[_c('div',{staticClass:"main-banner"}),_vm._v(" "),_c('banner-marcas',{staticClass:"banner-marca-home"}),_vm._v(" "),_c('banner-novedades'),_vm._v(" "),_c('banner-historia'),_vm._v(" "),_c('banner-curiosidades')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebf7ee2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home.vue
// module id = null
// module chunks = 